import * as React from 'react';
import { memo, useMemo, createElement, useCallback } from 'react';
import { useTheme as Et, useMotionConfig as Zr, textPropsByEngine as fi, degreesToRadians as ni } from '../../core/dist/nivo-core.es.js';
import { a as animated } from '../../../@react-spring/web/dist/react-spring_web.modern.js';
import { timeFormat } from '../../../d3-time-format/src/defaultLocale.js';
import '../../../d3-time/src/millisecond.js';
import '../../../d3-time/src/second.js';
import '../../../d3-time/src/minute.js';
import '../../../d3-time/src/hour.js';
import '../../../d3-time/src/day.js';
import '../../../d3-time/src/week.js';
import '../../../d3-time/src/month.js';
import '../../../d3-time/src/year.js';
import '../../../d3-time/src/utcMinute.js';
import '../../../d3-time/src/utcHour.js';
import '../../../d3-time/src/utcDay.js';
import '../../../d3-time/src/utcWeek.js';
import '../../../d3-time/src/utcMonth.js';
import '../../../d3-time/src/utcYear.js';
import '../../../d3-array/dist/d3-array.js';
import '../../../d3-time-format/src/isoFormat.js';
import '../../../d3-time-format/src/isoParse.js';
import { format } from '../../../d3-format/src/defaultLocale.js';
import '../../../d3-format/src/formatSpecifier.js';
import { getScaleTicks as kn, centerScale as pn } from '../../scales/dist/nivo-scales.es.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import '../../../prop-types/index.js';
import { exports as propTypesExports } from '../../../../_virtual/index2.js';
import { useTransition, useSpring } from '../../../@react-spring/core/dist/react-spring_core.modern.js';
function p() {
  return p = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, p.apply(this, arguments);
}
var b = function (t) {
    var e,
      i = t.axis,
      n = t.scale,
      r = t.ticksPosition,
      a = t.tickValues,
      l = t.tickSize,
      s = t.tickPadding,
      c = t.tickRotation,
      f = t.truncateTickAt,
      u = t.engine,
      d = void 0 === u ? "svg" : u,
      x = kn(n, a),
      h = fi[d],
      g = "bandwidth" in n ? pn(n) : n,
      k = {
        lineX: 0,
        lineY: 0
      },
      v = {
        textX: 0,
        textY: 0
      },
      b = "object" == typeof document && "rtl" === document.dir,
      T = h.align.center,
      P = h.baseline.center;
    "x" === i ? (e = function (t) {
      var e;
      return {
        x: null != (e = g(t)) ? e : 0,
        y: 0
      };
    }, k.lineY = l * ("after" === r ? 1 : -1), v.textY = (l + s) * ("after" === r ? 1 : -1), P = "after" === r ? h.baseline.top : h.baseline.bottom, 0 === c ? T = h.align.center : "after" === r && c < 0 || "before" === r && c > 0 ? (T = h.align[b ? "left" : "right"], P = h.baseline.center) : ("after" === r && c > 0 || "before" === r && c < 0) && (T = h.align[b ? "right" : "left"], P = h.baseline.center)) : (e = function (t) {
      var e;
      return {
        x: 0,
        y: null != (e = g(t)) ? e : 0
      };
    }, k.lineX = l * ("after" === r ? 1 : -1), v.textX = (l + s) * ("after" === r ? 1 : -1), T = "after" === r ? h.align.left : h.align.right);
    return {
      ticks: x.map(function (t) {
        var i = "string" == typeof t ? function (t) {
          var e = String(t).length;
          return f && f > 0 && e > f ? "" + String(t).slice(0, f).concat("...") : "" + t;
        }(t) : t;
        return p({
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          value: i
        }, e(t), k, v);
      }),
      textAlign: T,
      textBaseline: P
    };
  },
  T = function (t, e) {
    if (void 0 === t || "function" == typeof t) return t;
    if ("time" === e.type) {
      var i = timeFormat(t);
      return function (t) {
        return i(t instanceof Date ? t : new Date(t));
      };
    }
    return format(t);
  },
  P = function (t) {
    var e,
      i = t.width,
      n = t.height,
      r = t.scale,
      o = t.axis,
      a = t.values,
      l = (e = a, Array.isArray(e) ? a : void 0) || kn(r, a),
      s = "bandwidth" in r ? pn(r) : r,
      c = "x" === o ? l.map(function (t) {
        var e, i;
        return {
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          x1: null != (e = s(t)) ? e : 0,
          x2: null != (i = s(t)) ? i : 0,
          y1: 0,
          y2: n
        };
      }) : l.map(function (t) {
        var e, n;
        return {
          key: t instanceof Date ? "" + t.valueOf() : "" + t,
          x1: 0,
          x2: i,
          y1: null != (e = s(t)) ? e : 0,
          y2: null != (n = s(t)) ? n : 0
        };
      });
    return c;
  },
  S = memo(function (t) {
    var e,
      n = t.value,
      r = t.format,
      o = t.lineX,
      l = t.lineY,
      s = t.onClick,
      f = t.textBaseline,
      u = t.textAnchor,
      d = t.animatedProps,
      x = Et(),
      m = x.axis.ticks.line,
      y = x.axis.ticks.text,
      k = null != (e = null == r ? void 0 : r(n)) ? e : n,
      v = useMemo(function () {
        var t = {
          opacity: d.opacity
        };
        return s ? {
          style: p({}, t, {
            cursor: "pointer"
          }),
          onClick: function (t) {
            return s(t, k);
          }
        } : {
          style: t
        };
      }, [d.opacity, s, k]);
    return jsxs(animated.g, p({
      transform: d.transform
    }, v, {
      children: [jsx("line", {
        x1: 0,
        x2: o,
        y1: 0,
        y2: l,
        style: m
      }), y.outlineWidth > 0 && jsx(animated.text, {
        dominantBaseline: f,
        textAnchor: u,
        transform: d.textTransform,
        style: y,
        strokeWidth: 2 * y.outlineWidth,
        stroke: y.outlineColor,
        strokeLinejoin: "round",
        children: "" + k
      }), jsx(animated.text, {
        dominantBaseline: f,
        textAnchor: u,
        transform: d.textTransform,
        style: y,
        children: "" + k
      })]
    }));
  }),
  A = function (e) {
    var r = e.axis,
      o = e.scale,
      s = e.x,
      d = void 0 === s ? 0 : s,
      x = e.y,
      m = void 0 === x ? 0 : x,
      y = e.length,
      v = e.ticksPosition,
      P = e.tickValues,
      A = e.tickSize,
      W = void 0 === A ? 5 : A,
      O = e.tickPadding,
      w = void 0 === O ? 5 : O,
      B = e.tickRotation,
      X = void 0 === B ? 0 : B,
      Y = e.format,
      C = e.renderTick,
      z = void 0 === C ? S : C,
      V = e.truncateTickAt,
      j = e.legend,
      D = e.legendPosition,
      R = void 0 === D ? "end" : D,
      E = e.legendOffset,
      L = void 0 === E ? 0 : E,
      q = e.onClick,
      F = e.ariaHidden,
      H = Et(),
      N = H.axis.legend.text,
      I = useMemo(function () {
        return T(Y, o);
      }, [Y, o]),
      J = b({
        axis: r,
        scale: o,
        ticksPosition: v,
        tickValues: P,
        tickSize: W,
        tickPadding: w,
        tickRotation: X,
        truncateTickAt: V
      }),
      G = J.ticks,
      K = J.textAlign,
      M = J.textBaseline,
      Q = null;
    if (void 0 !== j) {
      var U,
        Z = 0,
        $ = 0,
        _ = 0;
      "y" === r ? (_ = -90, Z = L, "start" === R ? (U = "start", $ = y) : "middle" === R ? (U = "middle", $ = y / 2) : "end" === R && (U = "end")) : ($ = L, "start" === R ? U = "start" : "middle" === R ? (U = "middle", Z = y / 2) : "end" === R && (U = "end", Z = y)), Q = jsxs(Fragment, {
        children: [N.outlineWidth > 0 && jsx("text", {
          transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
          textAnchor: U,
          style: p({
            dominantBaseline: "central"
          }, N),
          strokeWidth: 2 * N.outlineWidth,
          stroke: N.outlineColor,
          strokeLinejoin: "round",
          children: j
        }), jsx("text", {
          transform: "translate(" + Z + ", " + $ + ") rotate(" + _ + ")",
          textAnchor: U,
          style: p({
            dominantBaseline: "central"
          }, N),
          children: j
        })]
      });
    }
    var tt = Zr(),
      et = tt.animate,
      it = tt.config,
      nt = useSpring({
        transform: "translate(" + d + "," + m + ")",
        lineX2: "x" === r ? y : 0,
        lineY2: "x" === r ? 0 : y,
        config: it,
        immediate: !et
      }),
      rt = useCallback(function (t) {
        return {
          opacity: 1,
          transform: "translate(" + t.x + "," + t.y + ")",
          textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
        };
      }, [X]),
      ot = useCallback(function (t) {
        return {
          opacity: 0,
          transform: "translate(" + t.x + "," + t.y + ")",
          textTransform: "translate(" + t.textX + "," + t.textY + ") rotate(" + X + ")"
        };
      }, [X]),
      at = useTransition(G, {
        keys: function (t) {
          return t.key;
        },
        initial: rt,
        from: ot,
        enter: rt,
        update: rt,
        leave: {
          opacity: 0
        },
        config: it,
        immediate: !et
      });
    return jsxs(animated.g, {
      transform: nt.transform,
      "aria-hidden": F,
      children: [at(function (e, i, n, r) {
        return React.createElement(z, p({
          tickIndex: r,
          format: I,
          rotate: X,
          textBaseline: M,
          textAnchor: K,
          truncateTickAt: V,
          animatedProps: e
        }, i, q ? {
          onClick: q
        } : {}));
      }), jsx(animated.line, {
        style: H.axis.domain.line,
        x1: 0,
        x2: nt.lineX2,
        y1: 0,
        y2: nt.lineY2
      }), Q]
    });
  },
  W = memo(A),
  O = {
    ticksPosition: propTypesExports.oneOf(["before", "after"]),
    tickValues: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.arrayOf(propTypesExports.oneOfType([propTypesExports.number, propTypesExports.string, propTypesExports.instanceOf(Date)])), propTypesExports.string]),
    rotateOnTickLength: propTypesExports.shape({
      angle: propTypesExports.number,
      length: propTypesExports.number
    }),
    tickSize: propTypesExports.number,
    tickPadding: propTypesExports.number,
    tickRotation: propTypesExports.number,
    format: propTypesExports.oneOfType([propTypesExports.func, propTypesExports.string]),
    renderTick: propTypesExports.func,
    legend: propTypesExports.node,
    legendPosition: propTypesExports.oneOf(["start", "middle", "end"]),
    legendOffset: propTypesExports.number,
    ariaHidden: propTypesExports.bool
  },
  w = propTypesExports.shape(O),
  B = ["top", "right", "bottom", "left"],
  X = memo(function (t) {
    var e = t.xScale,
      i = t.yScale,
      n = t.width,
      r = t.height,
      o = {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left
      };
    return jsx(Fragment, {
      children: B.map(function (t) {
        var a = o[t];
        if (!a) return null;
        var l = "top" === t || "bottom" === t;
        return jsx(W, p({}, a, {
          axis: l ? "x" : "y",
          x: "right" === t ? n : 0,
          y: "bottom" === t ? r : 0,
          scale: l ? e : i,
          length: l ? n : r,
          ticksPosition: "top" === t || "left" === t ? "before" : "after",
          truncateTickAt: a.truncateTickAt
        }), t);
      })
    });
  }),
  Y = memo(function (t) {
    var e = t.animatedProps,
      i = Et();
    return jsx(animated.line, p({}, e, i.grid.line));
  }),
  C = memo(function (t) {
    var e = t.lines,
      i = Zr(),
      n = i.animate,
      o = i.config,
      a = useTransition(e, {
        keys: function (t) {
          return t.key;
        },
        initial: function (t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        from: function (t) {
          return {
            opacity: 0,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        enter: function (t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        update: function (t) {
          return {
            opacity: 1,
            x1: t.x1,
            x2: t.x2,
            y1: t.y1,
            y2: t.y2
          };
        },
        leave: {
          opacity: 0
        },
        config: o,
        immediate: !n
      });
    return jsx("g", {
      children: a(function (t, e) {
        return createElement(Y, p({}, e, {
          key: e.key,
          animatedProps: t
        }));
      })
    });
  }),
  z = memo(function (t) {
    var e = t.width,
      n = t.height,
      r = t.xScale,
      o = t.yScale,
      a = t.xValues,
      l = t.yValues,
      s = useMemo(function () {
        return !!r && P({
          width: e,
          height: n,
          scale: r,
          axis: "x",
          values: a
        });
      }, [r, a, e, n]),
      c = useMemo(function () {
        return !!o && P({
          width: e,
          height: n,
          scale: o,
          axis: "y",
          values: l
        });
      }, [n, e, o, l]);
    return jsxs(Fragment, {
      children: [s && jsx(C, {
        lines: s
      }), c && jsx(C, {
        lines: c
      })]
    });
  }),
  V = function (t, e) {
    var i,
      n = e.axis,
      r = e.scale,
      o = e.x,
      a = void 0 === o ? 0 : o,
      l = e.y,
      c = void 0 === l ? 0 : l,
      f = e.length,
      u = e.ticksPosition,
      d = e.tickValues,
      x = e.tickSize,
      m = void 0 === x ? 5 : x,
      y = e.tickPadding,
      h = void 0 === y ? 5 : y,
      g = e.tickRotation,
      k = void 0 === g ? 0 : g,
      v = e.format,
      p = e.legend,
      T = e.legendPosition,
      P = void 0 === T ? "end" : T,
      S = e.legendOffset,
      A = void 0 === S ? 0 : S,
      W = e.theme,
      O = b({
        axis: n,
        scale: r,
        ticksPosition: u,
        tickValues: d,
        tickSize: m,
        tickPadding: h,
        tickRotation: k,
        engine: "canvas"
      }),
      w = O.ticks,
      B = O.textAlign,
      X = O.textBaseline;
    t.save(), t.translate(a, c), t.textAlign = B, t.textBaseline = X;
    var Y = W.axis.ticks.text;
    t.font = (Y.fontWeight ? Y.fontWeight + " " : "") + Y.fontSize + "px " + Y.fontFamily, (null != (i = W.axis.domain.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.domain.line.strokeWidth), t.lineCap = "square", W.axis.domain.line.stroke && (t.strokeStyle = W.axis.domain.line.stroke), t.beginPath(), t.moveTo(0, 0), t.lineTo("x" === n ? f : 0, "x" === n ? 0 : f), t.stroke());
    var C = "function" == typeof v ? v : function (t) {
      return "" + t;
    };
    if (w.forEach(function (e) {
      var i;
      (null != (i = W.axis.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(W.axis.ticks.line.strokeWidth), t.lineCap = "square", W.axis.ticks.line.stroke && (t.strokeStyle = W.axis.ticks.line.stroke), t.beginPath(), t.moveTo(e.x, e.y), t.lineTo(e.x + e.lineX, e.y + e.lineY), t.stroke());
      var n = C(e.value);
      t.save(), t.translate(e.x + e.textX, e.y + e.textY), t.rotate(ni(k)), Y.outlineWidth > 0 && (t.strokeStyle = Y.outlineColor, t.lineWidth = 2 * Y.outlineWidth, t.lineJoin = "round", t.strokeText("" + n, 0, 0)), W.axis.ticks.text.fill && (t.fillStyle = Y.fill), t.fillText("" + n, 0, 0), t.restore();
    }), void 0 !== p) {
      var z = 0,
        V = 0,
        j = 0,
        D = "center";
      "y" === n ? (j = -90, z = A, "start" === P ? (D = "start", V = f) : "middle" === P ? (D = "center", V = f / 2) : "end" === P && (D = "end")) : (V = A, "start" === P ? D = "start" : "middle" === P ? (D = "center", z = f / 2) : "end" === P && (D = "end", z = f)), t.translate(z, V), t.rotate(ni(j)), t.font = (W.axis.legend.text.fontWeight ? W.axis.legend.text.fontWeight + " " : "") + W.axis.legend.text.fontSize + "px " + W.axis.legend.text.fontFamily, W.axis.legend.text.fill && (t.fillStyle = W.axis.legend.text.fill), t.textAlign = D, t.textBaseline = "middle", t.fillText(p, 0, 0);
    }
    t.restore();
  },
  j = function (t, e) {
    var i = e.xScale,
      n = e.yScale,
      r = e.width,
      o = e.height,
      a = e.top,
      l = e.right,
      s = e.bottom,
      c = e.left,
      f = e.theme,
      u = {
        top: a,
        right: l,
        bottom: s,
        left: c
      };
    B.forEach(function (e) {
      var a = u[e];
      if (!a) return null;
      var l = "top" === e || "bottom" === e,
        s = "top" === e || "left" === e ? "before" : "after",
        c = l ? i : n,
        d = T(a.format, c);
      V(t, p({}, a, {
        axis: l ? "x" : "y",
        x: "right" === e ? r : 0,
        y: "bottom" === e ? o : 0,
        scale: c,
        format: d,
        length: l ? r : o,
        ticksPosition: s,
        theme: f
      }));
    });
  },
  D = function (t, e) {
    var i = e.width,
      n = e.height,
      r = e.scale,
      o = e.axis,
      a = e.values;
    P({
      width: i,
      height: n,
      scale: r,
      axis: o,
      values: a
    }).forEach(function (e) {
      t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke();
    });
  };
export { X as Axes, W as Axis, S as AxisTick, z as Grid, Y as GridLine, C as GridLines, A as NonMemoizedAxis, w as axisPropType, O as axisPropTypes, B as positions, j as renderAxesToCanvas, V as renderAxisToCanvas, D as renderGridLinesToCanvas };
//# sourceMappingURL=nivo-axes.es.js.map
